import * as React from 'react';
import { UserState } from '../../../interface/MyInterfaces';
import { EmployeeReportState } from '../../../interface/EmployeeReportInterface';
import { EmployeeMatchReportTable } from './EmployeeMatchReportTable'
import * as Helpers from '../../Common/Helpers';
import renderHTML from 'react-render-html';

//track user visit
import { withUserActionTracker } from './../../../sharedUtilities/UserActionTracker';

class EmployeeMatchReportTab extends React.Component<UserState & EmployeeReportState, {}> {
    constructor(props) {
        super(props);
        this.bullets = this.bullets.bind(this);
    }

    bullets() {
        if (this.props.EmployeeReport_MatchRateTab !== undefined) {
            return renderHTML(this.props.EmployeeReport_MatchRateTab.bullets);
        }
        else
            return "loading..."
    }

    public render() {
        return <div className='tabcontents container-fluid'>
            <div className='row'>
                <div className='col-md-12 matchreport'>
                    <h3>Matching Rates & Process for {this.props.EmployeeProfileInfo && this.props.EmployeeProfileInfo.the_university} Data</h3>
                    <h5>Overview</h5>
                    <p>This memo presents details and outcomes of the matching process conducted by the	U.S. Census Bureau to integrate your IRIS data with the Census data resources. The memo provides context	for those matching outcomes, which we hope will	enhance	the interpretability and utility of the	data presented in your university reports. We also highlight potential issues to be addressed as IRIS continues to develop products based on linked IRIS-Census data.	At each stage we highlight work	that IRIS, the universities, and Census can do to improve the overall quality.</p>

                    <h5>Employee Match</h5>
                        <p>The QA reports are organized	around two different views of the data. The first describes the	process	by which research employees at your university are matched to Census Data. There are three key steps in	this process:</p>
                        {this.bullets()}
                    </div>
                    <h5>Employee Data Processing Steps-{this.props.EmployeeProfileInfo && this.props.EmployeeProfileInfo.the_university}</h5>
                    <p>The purpose of this chart is	to explain how data	are	processed, matched, and aggregated to produce the Hot Report. Each step	of the process includes	suggestions	to improve the results.</p>
                    <EmployeeMatchReportTable EmployeeMatchRate={this.props.EmployeeMatchRate} />
            </div>
        </div>;
    }
}

export default withUserActionTracker(EmployeeMatchReportTab, "Census Supplemental Employee Profile Report", "viewed Match Report Tab")